"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PetSureCopyright = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PetSureCopyright = () => {
  const now = new Date();
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "PetSureCopyright"
  }, "\xA9 ", now.getFullYear(), " PetSure (Australia) Pty Ltd. All Rights Reserved.");
};
exports.PetSureCopyright = PetSureCopyright;
var _default = exports.default = PetSureCopyright;